var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "job-vita--section" }, [
    _c("div", { staticClass: "job-vita--section-title" }, [
      _vm._v(_vm._s(_vm.freetextData.title))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pl-3 pl-md-5 pb-4" }, [
      _vm._v(_vm._s(_vm.freetextData.text))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }